import 'font-awesome/css/font-awesome.css'


import Vue from 'vue'
import App from './App'
import store from './config/store'
import router from './config/router'
import vuetify from './plugins/vuetify';
import VuePlyr from 'vue-plyr'

import './config/msgs'
import './config/axios'
// import 'kalendar-vue/dist/KalendarVue.css';



//https://vuejsfeed.com/blog/v-calendar-a-clean-and-lightweight-calendar-plugin-for-vue-js

Vue.config.productionTip = false
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false  },
  },
  emit: ['ended']
})

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
